


























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Floor from "../../../store/entities/floor";
class PagefloorRequest{
  ftId:Number;
}
@Component
export default class CreateFloor extends AbpBase {
  pagefloorrequest: PagefloorRequest = new PagefloorRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  floor: Floor = new Floor();
  idisable:boolean = false;
  selwarehouselist = [];
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.floorForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true
        await this.$store.dispatch({
          type: "floor/create",
          data:this.floor
        });
        (this.$refs.floorForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.floorForm as any).resetFields();
            this.$emit('input',false);
        }
  floorRule = {
    ftId: [{ type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{ type:"number",required: true, message: "请选择库房", trigger: "change" }],
    fName: [{ required: true, message: "请填写楼层名称", trigger: "blur" }],
    number: [{required: true, message: "请填写楼层编号", trigger: "blur" }],
  };
  get factory() {
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagefloorrequest,
    });
  }
  floorchange(value:Number){
    this.pagefloorrequest.ftId = value;
      this.getselwarehouse();
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.pagefloorrequest,
    });
  }
}
